import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full h-[550px] flex flex-col" }
const _hoisted_2 = { class: "w-full h-[38px] bg-white dark:bg-darkCardBg rounded-lg flex items-center justify-between px-2" }
const _hoisted_3 = { class: "flex items-center my-2" }
const _hoisted_4 = { class: "flex flex-grow w-full mt-2 overflow-hidden" }
const _hoisted_5 = { class: "flex flex-grow bg-white dark:bg-darkCardBg rounded-lg items-center h-full" }
const _hoisted_6 = { class: "flex flex-col flex-grow h-full" }
const _hoisted_7 = { class: "flex items-center py-2 px-2" }
const _hoisted_8 = { class: "flex-grow relative overflow-hidden" }
const _hoisted_9 = { class: "w-[65px] h-full py-2 pr-2 flex flex-col justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_divider = _resolveComponent("n-divider")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_n_skeleton, {
          class: "rounded-md",
          height: 20,
          width: 20
        }),
        _createVNode(_component_n_skeleton, {
          class: "rounded-md ml-2",
          height: 20,
          width: 70
        }),
        _createVNode(_component_n_skeleton, {
          circle: "",
          class: "ml-2",
          height: 20,
          width: 20
        }),
        _createVNode(_component_n_divider, { vertical: "" }),
        _createVNode(_component_n_skeleton, {
          class: "rounded-md",
          height: 20,
          width: 20
        }),
        _createVNode(_component_n_divider, { vertical: "" }),
        _createVNode(_component_n_skeleton, {
          class: "rounded-md",
          height: 20,
          width: 20
        }),
        _createVNode(_component_n_divider, { vertical: "" }),
        _createVNode(_component_n_skeleton, {
          class: "rounded-md",
          height: 20,
          width: 120
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_n_skeleton, {
              class: "rounded-md",
              height: 25,
              width: 120
            }),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
              return _createVNode(_component_n_skeleton, {
                key: i,
                class: "rounded-md ml-3",
                height: 15,
                width: 60
              })
            }), 64))
          ]),
          _createElementVNode("section", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bars, (bar, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                _createVNode(_component_n_skeleton, {
                  class: "absolute",
                  style: _normalizeStyle(`bottom: ${bar.low}px; left: ${i * bar.width - Math.ceil(bar.width/2)}px;`),
                  height: bar.high - bar.low,
                  width: 1
                }, null, 8, ["style", "height"]),
                _createVNode(_component_n_skeleton, {
                  class: "absolute",
                  style: _normalizeStyle(`bottom: ${bar.close}px; left: ${i * bar.width}px;`),
                  height: bar.open - bar.close,
                  width: bar.width
                }, null, 8, ["style", "height", "width"])
              ], 64))
            }), 128))
          ])
        ]),
        _createVNode(_component_n_divider, {
          vertical: "",
          class: "h-full"
        }),
        _createElementVNode("section", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(23, (i) => {
            return _createVNode(_component_n_skeleton, {
              key: i,
              class: "rounded-md w-full",
              height: 10
            })
          }), 64))
        ])
      ])
    ])
  ]))
}